import { createMuiStyles } from '../../utils/mui';

// Card styles for program, scholarship and institute on grid view
export const moduleCardStyles = createMuiStyles({
  card: {
    width: '100%',
    borderRadius: '0.5rem',
    display: 'block',
    textDecoration: 'none',
    height: 1,
    color: 'common.black',
    bgcolor: 'grey.50',
    h6: {
      transition: '0.3s',
    },
    '&:hover': {
      h6: {
        color: 'primary.main',
      },
    },
  },
  header: {
    position: 'relative',
  },
  headerWithImage: {
    borderBottom: (theme) => `1px solid ${theme.palette.grey[100]}`,
    borderTopLeftRadius: '0.5rem',
    borderTopRightRadius: '0.5rem',
    overflow: 'hidden',
    '.WishlistBtn-root': {
      position: 'absolute',
      top: 0,
      right: 0,
    },
    img: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      color: 'secondary.main',
      fontWeight: 'Medium',
      maxWidth: '100%',
      py: 1,
      height: '15rem',
      width: '100%',
      objectFit: 'contain',
      objectPosition: 'center',
    },
  },
  imgContainer: {
    img: {
      p: 0.5,
      height: { xs: '4rem', md: '5rem' },
      width: { xs: '4rem', md: '5rem' },
      overflow: 'hidden',
      display: 'block',
      borderRadius: '50%',
      objectFit: 'contain',
      objectPosition: 'center',
      bgcolor: 'common.white',
    },
  },
  wishlistBtn: {
    mr: 3,
    mt: 3,
  },
  providerLabel: {
    '&::before': {
      height: '0.25rem',
      width: '0.25rem',
      content: '""',
      display: 'inline-block',
      mr: 0.5,
      borderRadius: '50%',
      bgcolor: 'secondary.main',
      verticalAlign: 'middle',
      mb: 0.5,
    },
  },
  discountBadge: {
    cursor: 'inherit',
    borderRadius: '0.25rem',
    '.MuiChip-label': {
      px: 1,
      fontWeight: 'Regular',
    },
  },
});
